import { TutorialStep } from "..";

export const InspStatusSteps: TutorialStep[] = [
  {
    target: "#insp-status",
    content: `이는 검사 진행 후 검사결과 이미지들을 확인할 수 있는 페이지입니다.`,
    spotlightClicks: false,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#status-filter",
    content: `상단의 필터를 통해 특정 데이터들을 필터링 할 수 있습니다.`,
    spotlightClicks: false,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#status-filter",
    content: `임시로 material name에 "test"를 입력하여 검색해봅시다.`,
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    nextTrigger: "#status-table",
    disableOverlayClose: true,
  },
  {
    target: "#status-table",
    content: `검색 후, 하단의 테이블에서 검사결과 이미지들을 확인할 수 있습니다.`,
    spotlightClicks: false,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#status-row",
    content: `데이터를 클릭하여 상세 정보를 확인해봅시다.`,
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    nextTrigger: "#status-modal",
    disableOverlayClose: true,
  },
  {
    target: "#status-modal",
    content: `해당 이미지에 대한 상세 정보 및 결과를 확인할 수 있습니다.`,
    spotlightClicks: false,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
];
